import { FC } from 'react';
import { Link } from 'react-router-dom';
import useAppState from '../../state/appState';
import { trackUserClickedEditOnResumePage } from '../../utils/tracking';
import { scrollPageToTop } from '../../helpers/scrollPageToTop';

type NavToElementPageProps = {
    elementId: string;
};

const NavToElementPage: FC<NavToElementPageProps> = ({ elementId }) => {
    const formConfig = useAppState((state) => state.formConfig);

    const setError = useAppState((state) => state.setError);

    if (!formConfig) {
        return <></>;
    }

    const onClickHandler = () => {
        scrollPageToTop();
        resetError();

        trackUserClickedEditOnResumePage(formConfig, elementId);
    };

    const resetError = () => {
        setError('');
    };

    const { formId, pages } = formConfig;
    const elementPage = pages.find((page) => page.elements.find((element) => element.elementId === elementId));

    if (!elementPage) {
        return <></>;
    }

    return (
        <Link className="flos-link flos-link--logo" to={`/${formId}/${elementPage.pageId}`} onClick={onClickHandler}>
            Redigér
        </Link>
    );
};

export default NavToElementPage;
